export const GoogleMapApiConfig = 'AIzaSyBKZ1TfPhnBv7NZcK13kVkGTkYEF7b9gNs';